export const TOOLTIPS = {
    // VERSION_GRAPH_BUTTON_TOOLTIPS
    PROJECT_VERSION_HISTORY: 'Project Version History',

    // SETTINGS_TOOLTIPS
    PROJECT_SETTINGS: 'Project Settings',
    PROJECT_VARIANT_VERSION_SETTINGS: 'Project Line Version Settings',
    SOFTWARE_COMPONENT_SETTINGS: 'Software Component Settings',
    COMPOSITION_SETTINGS: 'Composition Settings',
    DEPLOYMENT_UNIT_SETTINGS: 'Deployment Unit Settings',

    // NAVIGATION_TOOLTIPS
    LOAD_PROJECT: 'Load Project',
    OPEN_DATA_DICTIONARY_VERSION: 'Open Data Dictionary',
    LOAD_PROJECT_VARIANT_VERSION: 'Load Project Line Version',
    LOAD_SOFTWARE_COMPONENT: 'Load Software Component',
    LOAD_COMPOSITION: 'Load Composition',

    // EDITOR_TOOLTIPS
    GRAPHICAL_EDITOR: 'Open Graphical Editor',

    // REFERENCE TEXT FIELD
    EDIT_REFERENCE: 'Edit Reference',
    GO_TO_REFERENCE: 'Go to Reference',
    SEARCH_FOR_REFERENCE: 'Search for Reference',
    CREATE_NEW_REFERENCE: 'Create Reference',
    // LOCAL AXIS REFERENCE TEXT FIELD
    CREATE_REFERENCE_OR_EMBEDDED_AXIS: 'Create Reference or Embedded Axis',
    // SYS CONST
    NO_SYSTEM_CONSTANT_REFERENCE: 'No System Constant Reference',

    CREATE_SOFTWARE_RECORD_LAYOUT_GROUP: 'Create Software Record Layout Group',
    CREATE_SOFTWARE_RECORD_LAYOUT_VALUE: 'Create Software Record Layout Value',

    // MENUBAR
    SYSTEM_ANNOUNCEMENT: 'System Announcements',
    HELP: 'Help',
    DOCUMENTATION: 'Documentation',
    SETTINGS: 'Settings',
    USER: 'User',
    ADMIN_PANEL: 'Admin Panel',
    PROJECTS: 'Projects',
    COLOR_SCHEME: 'Color Scheme',

    // Naming Conventions
    NAMING_CONVENTIONS: 'Naming Conventions',
    OPEN_NAMING_CONVENTION: 'Open Naming Convention',
    NAMING_CONVENTION_VERSION_HISTORY: 'Naming Convention Version History',
    DELETE_NAMING_CONVENTION: 'Delete Naming Convention',
    DELETE_NAMING_CONVENTION_GRAMMAR: 'Delete Naming Convention Grammar',

    // STATUSBAR
    DISMISS: 'Dismiss',
    STOP_PROCESS: 'Stop Process',
    ERROR: 'Error',
    TASK_INFO: 'Details',

    LOAD_VIDEO: 'Load Video',

    // OTHER
    VIEW: 'View',
    EDIT: 'Edit',
    DELETE: 'Delete',
    VALIDATION_RESULT: 'Resource Information',
    METADATA: 'Resource metadata',
    RESOURCE_AFFECTED_MAPPINGS: 'Mappings affected by resource',
    CONVERT_TT_TO_ENUM: 'Convert TextTable to Enum',
    CONVERT_ENUM_TO_TT: 'Convert Enum to TextTable',
    UNUSED: 'Resource is unused',
    USED_BY: 'Resource Used By ...',
    INVALID_NUMERIC: 'Invalid Numeric',
    SAVE: 'Save',
    CANCEL: 'Cancel',
    DELETE_ARRAY_SIZE: 'Delete Array Size',
    DELETE_VALUE_LIST: 'Delete Value List',
    DELETE_VALUE: 'Delete Value',
    MAP_VARIANT: 'Map Variant',
    MAP_VERSION: 'Map Version',
    DELETE_PROJECT: 'Delete Project',

    // TREE MENU ITEM
    MAPPING_STATE_OPEN: 'Mapping state is open',
    USER_IS_NOT_AN_ARCHITECT: 'User is not an Architect',

    // GRAMMAR RULE GRAPHICAL EDITOR
    ORGANIZE_NODES: 'Organize nodes',
    ADD_KEYWORD_CATEGORY: 'Add keyword category',
    INTERACTION_ON: 'Interaction on',
    INTERACTION_OFF: 'Interaction off',

    // A2L EXPORT CONFIGURATION
    SAVE_A2L_EXPORT_CONFIGURATION: 'Save A2L export configuration',
    DELETE_A2L_EXPORT_CONFIGURATION: 'Delete A2L export configuration',

    // VERSION HISTORY GRAPH
    FIT_VIEW: 'Auto-fit view',
    POSITION_TO_ACTIVE_NODE: 'Position to active node',
    SHOW_MINI_MAP: 'Show mini map',
    HIDE_MINI_MAP: 'Hide mini map',

    DOWNLOAD: 'Download',
    IMPORT: 'Import PVT',
    CREATE_NEW_PROJECT: 'Create new Project',
};


